import React, { Component } from 'react';
import * as d3 from 'd3'
import './style.css';

let width = 150

let colourScale = d3.scaleLinear().domain([0, 0.5, 1]).range(['#67AC6D', '#aaa', '#FD666B'])

class SurveySectionResultSlider extends Component {

  componentDidMount(props) {
    this.update(this.props)
  }

  componentDidUpdate(props) {
    this.update(props)
  }

  update() {
    // console.log('update slider', this.props)
    let scale = d3.scaleLinear().range([0, width])
    this.props.reverse ? scale.domain([1, 0]) : scale.domain([0, 1])

    d3.select(this.circleEl)
      .transition()
      .duration(1000)
      .attr('cx', scale(this.props.value))
  }

  render() {

    return (
      <div className="survey-section-result-slider">
        <svg width={(width + 130) + 'px'} height="40px">
          <g transform="translate(60, 20)">
            <line x2={width} />
            <circle r="8" ref={el => this.circleEl = el} fill={colourScale(this.props.value)} />

            <text x="-10" y="10" style={{'textAnchor': 'end'}}>Worse</text>
            <text x={width + 10} y="10">Better</text>

          </g>

        </svg>
      </div>
    );
  }
}

export default SurveySectionResultSlider;



// WEBPACK FOOTER //
// ./src/SurveySectionResultSlider/index.js